import React, { createContext, useCallback, useContext, useMemo, useRef, useState } from "react";

// Simple loading coordinator: components can mark critical tasks as pending
// and the App can wait for pendingCount === 0 before hiding the preloader.

const LoadingContext = createContext({
  beginTask: /** @param {string} id */ () => {},
  endTask: /** @param {string} id */ () => {},
  pendingCount: 0
});

export const LoadingProvider = ({ children }) => {
  const [pendingCount, setPendingCount] = useState(0);
  const tasksRef = useRef(new Set());

  const beginTask = useCallback((id) => {
    if (!id) return;
    const set = tasksRef.current;
    if (!set.has(id)) {
      set.add(id);
      setPendingCount(set.size);
    }
  }, []);

  const endTask = useCallback((id) => {
    if (!id) return;
    const set = tasksRef.current;
    if (set.has(id)) {
      set.delete(id);
      setPendingCount(set.size);
    }
  }, []);

  const value = useMemo(() => ({ beginTask, endTask, pendingCount }), [beginTask, endTask, pendingCount]);

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};

export const useLoading = () => useContext(LoadingContext);

export default LoadingContext;
